import React from "react";
import { useTranslations } from "hooks/useTranslations";
import {
  Box,
  Checkbox,
  FormControlLabel,
  SxProps,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  shoppingCartSelector,
  setTermsAndConditions,
} from "redux/shoppingCart";

interface IProps {
  sxProps?: SxProps;
}
export const TermsAndConditions = ({ sxProps }: IProps) => {
  const dispatch = useDispatch();
  const shoppingCart = useSelector(shoppingCartSelector);

  const {
    urlReplaceKey,
    url,
    urlText,
    description,
    privacyReplaceKey,
    privacyUrl,
    privacyUrlText,
  } = useTranslations().translations.termsAndConditions;

  const getLabelText = () => {
    const PrivacyLink = () => (
      <a style={{ whiteSpace: "nowrap" }} target="_blank" href={privacyUrl}>
        {privacyUrlText}
      </a>
    );

    const TermsLink = () => (
      <a style={{ whiteSpace: "nowrap" }} target="_blank" href={url}>
        {urlText}
      </a>
    );

    const delimiter = /(#.*?#)/;
    const arr = description.split(delimiter);
    const result = arr.map((item: string, index) => {
      if (item === privacyReplaceKey) {
        return <PrivacyLink key={"item" + index} />;
      } else if (item === urlReplaceKey) {
        return <TermsLink key={"item" + index} />;
      } else {
        return <React.Fragment key={"item" + index}>{item}</React.Fragment>;
      }
    });
    return result;
  };

  const handleTermsAndConditionsChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    dispatch(setTermsAndConditions(e.target.checked));
  };

  return (
    <Box
      sx={{
        p: { xs: 2, md: 0 },
        pl: { xs: 0.5, md: 0 },
        ...(sxProps as SxProps),
      }}
    >
      <FormControlLabel
        sx={sxValues.termsAndConditionsLabel}
        control={
          <Checkbox
            onChange={handleTermsAndConditionsChange}
            checked={shoppingCart.acceptedTermsAndConditions}
            inputProps={{ "aria-label": "controlled" }}
          />
        }
        label={
          <Typography variant="titleExtraSmall">{getLabelText()}</Typography>
        }
      />
    </Box>
  );
};

const sxValues: { [key: string]: SxProps } = {
  termsAndConditionsLabel: {
    m: 0,
  },
};
